/**
 * Card number input used for adding a card
 *
 * Dependent on getCardSpecs() from https://github.paypal.com/ConsumerWeb-Modules/consumerweb-card/blob/master/lib/card-config.js,
 * but you could just supply an object of specifications similar to what getCardSpecs returns.
 */

import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { StyleSheet, css } from 'aphrodite';
import { TextInput } from '@paypalcorp/pp-react-text-input' 

const STYLES = {
	logoWrapper: {
		height: '100%',
		position: 'absolute',
		top: 0,
		right: 0
	},

	dropdown: {
		padding: 0,
		textIndent: 10,
		WebkitAppearance: 'none',
		MozAppearance: 'none',
		appearance: 'none'
	},

	arrow: {
		position: 'absolute',
		right: 10,
		top: 20,
		cursor: 'default',
	},

	logo: {
		display: 'inline-block',
		marginTop: 12,
		marginRight: 2
	},

	errorMessage: {
		WebkitTransition: 'all 0.25s ease-in-out',
		MozTransition: 'all 0.25s ease-in-out',
		msTransition: 'all 0.25s ease-in-out',
		OTransition: 'all 0.25s ease-in-out',
		transition: 'all 0.25s ease-in-out'
	}
};

class IssueNumber extends React.Component {
	constructor() {
		super();
		this.state = {
			issueNumber: ''
		};
	}

	handleChange = (value) => {
		this.setState({ issueNumber: value });
		this.props.handleChange(value);
		return value;
	}

	handleFocus = () => {
		this.props.handleFocus();
	}

	/**
	 * Check for a issue number value
	 * If the field is required, we should show that this field needs a value
	 * @param {String} issueNumber - the csc
	 */
	handleCheckForValue(issueNumber) {
		const cscSpecs = this.props.cardSpec.fields.csc;
		const isRequired = cscSpecs.required;
		this.setState({ showIsRequiredError: isRequired && !issueNumber });
	}

	handleBlur = (issueNumber) => {
		this.handleCheckForValue(issueNumber);
		this.props.handleBlur(issueNumber);
	}

	render() {
		const issueNumberSpecs = this.props.cardSpec.fields.issueNumber;

		let { errorMessage } = this.props;
		let errorStyles = {
			height: 0,
			padding: 0
		};
		if (errorMessage) {
			errorStyles = { height: '100%' };
		}

		return (
			<div style={{ marginTop: 10, textAlign: 'left' }}>
				{
					// <label style={{ 'marginBottom': 0, fontWeight: 'bold' }}>{this.props.label}</label>
				}
				<div className={classNames({
                    'vx_has-error-with-message': errorMessage,
                    "ppvx_field--error": !errorMessage && this.state.showIsRequiredError
                })} style={{ position: 'relative' }}>
					<TextInput type="tel"
						id="issueNumber"
						name="issueNumber"
						className="vx_form-control vx_form-control_complex"
						label={this.props.placeholder}
						maxLength={issueNumberSpecs.maxlength}
						pattern={undefined}
						required={this.props.required}
						onChange={(event) => this.handleChange(event.target.value)}
						onFocus={(event) => this.handleFocus(event.target.value)}
						onBlur={(event) => this.handleBlur(event.target.value)}
						errorText={errorMessage}
					/>
				</div>
			</div>
		);
	}
};

IssueNumber.propTypes = {
	handleChange: PropTypes.func.isRequired
};

export default IssueNumber;
